import _  from "lodash";
import { useMemo } from 'react'
import { useSelector } from "react-redux";
import { isAllowed, filterRules } from "./permissions";
import { isNewTenancyEnabled } from "utils/localstorage";
import useCurrentService from "./useCurrentService";

export default (_permissionKeys, otherTabs) => { 
    const { permissions, selectedScope } = useSelector(state => state.tenancy);
    const isTenancyV4 = isNewTenancyEnabled();
    // Page level permissionKeys
    const currentService = useCurrentService();
    const permissionKeys = _permissionKeys || currentService?.permissionKeys;

    const pemissionKeysDetails = useMemo(() => {
        const keyMap = {}
        if (isTenancyV4 && !_.isEmpty(permissionKeys)) {
            for(const permissionKey of permissionKeys) {
                const rules = filterRules(selectedScope?.rules, permissionKey);
                keyMap[permissionKey] = rules
            }
        }
        return { keyMap };
    }, [permissionKeys, selectedScope])

    const getRules = (permissionKey) => {
        if (!_.isEmpty(pemissionKeysDetails?.keyMap) && !_.isUndefined(pemissionKeysDetails?.keyMap[permissionKey])) {
            return pemissionKeysDetails?.keyMap[permissionKey]
        } else {
            return selectedScope?.rules
        }
    }

    const isAllowedOperation = ({permissionKey, permissionType, permissionTypes}) => {
        if (!_.isUndefined(permissionType)) {
            return isAllowed(getRules(permissionKey), permissionKey, permissionType);
        } else if (!_.isEmpty(permissionTypes)) {
            const isPermissionByTypes = permissionTypes.map(
                (permissionType) => isAllowed(getRules(permissionKey), permissionKey, permissionType),
            );
            return isPermissionByTypes.some(Boolean);
        }
    }


    const hasPermission = ({permissionKey, permissionType, permissionTypes = ["access", "read"]}) => {
        if (!isTenancyV4) {
            return (permissions.allTabsAvailable || !otherTabs) && (permissions.editAccount)
        } else {
            if(!_.isUndefined(permissionKey)) {
                // Direct check a single permissionKey and permissionType
                return isAllowedOperation({permissionKey, permissionType, permissionTypes})
            } else if(!_.isEmpty(permissionKeys)) {
                const isPermissionKeys = permissionKeys.map(
                    (permissionKey) => isAllowedOperation({permissionKey, permissionType, permissionTypes})
                );
                return isPermissionKeys.some(Boolean);
            } else {
                return true
            }
        }
    }
    
    return hasPermission;
}